import _ from 'lodash';

const CicFieldReasonsFormTestIdsScope = {
  FORM: 'cic-field-reasons',
};

const getRowScope = field => `row-${_.kebabCase(field)}`;

const getFeeRowScope = feeTypeId => `fee-${feeTypeId}`;

export const CicFieldReasonsFormTestIds = {
  FORM: `${CicFieldReasonsFormTestIdsScope.FORM}.reasons-form`,
  COPY_FIRST_ROW_BUTTON: `${CicFieldReasonsFormTestIdsScope.FORM}.copy-first-row-button`,
  RECALCULATED_FIELDS_LABEL: `${CicFieldReasonsFormTestIdsScope.FORM}.recalculated-fields-label`,
  SAVE_MESSAGE_LABEL: `${CicFieldReasonsFormTestIdsScope.FORM}.save-message-label`,
  NO_REASONS_LABEL: `${CicFieldReasonsFormTestIdsScope.FORM}.no-reasons-label`,
  LOAD_ERROR_LABEL: `${CicFieldReasonsFormTestIdsScope.FORM}.load-error-label`,
  PROGRESS_LABEL: `${CicFieldReasonsFormTestIdsScope.FORM}.progress-label`,
  LOADING_SPINNER: `${CicFieldReasonsFormTestIdsScope.FORM}.loading-spinner`,
  CANCEL_BUTTON: `${CicFieldReasonsFormTestIdsScope.FORM}.cancel-button`,
  CONFIRM_BUTTON: `${CicFieldReasonsFormTestIdsScope.FORM}.confirm-button`,
  FEE_SECTION: `${CicFieldReasonsFormTestIdsScope.FORM}.fee-section`,
  getFeeRowId: feeTypeId => `${CicFieldReasonsFormTestIdsScope.FORM}.${getFeeRowScope(feeTypeId)}`,
  getFeeReasonSelectId: feeTypeId => `${getFeeRowScope(feeTypeId)}.reason-select`,
  getFeeReasonInputId: feeTypeId => `${getFeeRowScope(feeTypeId)}.reason-input`,
  getFeeReasonOptionId: feeTypeId => `${getFeeRowScope(feeTypeId)}.reason-option`,
  getFeeReasonHelpId: feeTypeId => `${getFeeRowScope(feeTypeId)}.reason-help`,
  getFeeNoLinkedReasonsId: feeTypeId => `${getFeeRowScope(feeTypeId)}.no-linked-reasons`,
  getFeeTemplateSelectId: feeTypeId => `${getFeeRowScope(feeTypeId)}.template-select`,
  getFeeTemplateInputId: feeTypeId => `${getFeeRowScope(feeTypeId)}.template-input`,
  getFeeTemplateOptionId: feeTypeId => `${getFeeRowScope(feeTypeId)}.template-option`,
  getFeeNoteInputId: feeTypeId => `${getFeeRowScope(feeTypeId)}.note-input`,
  getFeeCureCheckboxId: feeTypeId => `${getFeeRowScope(feeTypeId)}.cure-checkbox`,
  getFeeCureButtonId: feeTypeId => `${getFeeRowScope(feeTypeId)}.cure-button`,
  getRowId: field => `${CicFieldReasonsFormTestIdsScope.FORM}.${getRowScope(field)}`,
  getReasonSelectId: field => `${getRowScope(field)}.reason-select`,
  getReasonInputId: field => `${getRowScope(field)}.reason-input`,
  getReasonOptionId: field => `${getRowScope(field)}.reason-option`,
  getTemplateSelectId: field => `${getRowScope(field)}.template-select`,
  getTemplateInputId: field => `${getRowScope(field)}.template-input`,
  getTemplateOptionId: field => `${getRowScope(field)}.template-option`,
  getCommentInputId: field => `${getRowScope(field)}.comment-input`,
  getDisclosureLabelId: field => `${getRowScope(field)}.disclosure-label`,
};
